import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { appendTestableElementAttributes, Text, TextSeparator, TextSeparatorType } from '@dreryk/react-components';

import { StyledPatientAutosuggestItemName } from './PatientAutosuggestItemName.styled';

type PatientAutosuggestItemNameProps = { patient: PatientSimple };

export const PatientAutosuggestItemName = (props: PatientAutosuggestItemNameProps): JSX.Element => {
   return (
      <StyledPatientAutosuggestItemName {...appendTestableElementAttributes('name')}>
         <TextSeparator separator={TextSeparatorType.SPACE}>
            {props.patient.lastName ? <Text testId={'lastName'}>{props.patient.lastName.asString()}</Text> : null}

            {props.patient.firstName ? <Text testId={'firstName'}>{props.patient.firstName.asString()}</Text> : null}
         </TextSeparator>
      </StyledPatientAutosuggestItemName>
   );
};
